import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TableColumnsDto } from '../../../models/dtos/tableColumns.dto';
import { ErrorDto } from '../../../models/dtos/error.dto';
import getSubCompaniesRequest from './getTableColumns.repository';
import { Errors } from '../../errors';

type InitialState = {
  loading: boolean;
  data?: TableColumnsDto;
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};
export const getTableColumns = createAsyncThunk('getTableColumns', async (tableName: string) => {
  return await getSubCompaniesRequest(tableName).catch((error) => {
    throw error;
  });
});
export const TableColumnsSlice = createSlice({
  initialState,
  name: 'TableColumnsSlice',
  reducers: {
    TableColumnsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTableColumns.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTableColumns.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    });
    builder.addCase(getTableColumns.rejected, (state, { error }) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(error);
    });
  },
});
export const { TableColumnsReset } = TableColumnsSlice.actions;
export default TableColumnsSlice.reducer;
